import { useContext } from 'react';

import { generatePath, useNavigate } from 'react-router-dom';

import TableBodyCell from 'components/common/Table/TableBodyCell/TableBodyCell';
import TableRow from 'components/common/Table/TableRow/TableRow';
import { BorrowerApplicationDto } from 'components/applications/applications.dto';
import {
  APPLICATION_TABLE_EMPTY_VALUE,
  DEFAULT_APPLICATIONS_TABLE_FILTERS,
} from 'components/applications/applications.constants';
import {
  convertBorrowerNames,
  convertLoanAmount,
  getLoanDecision,
  convertStatus,
} from 'components/applications/applications.utils';
import { StatusCategoryTab } from 'components/applications/applications.enums';
import { ApplicationRoute } from 'routes/routes.enums';
import { DateFormats } from 'common/dates/date.enums';
import { getDateWithFormat } from 'common/dates/date.utils';
import { RootStoreContext } from 'index';
import { prepareVariableForTableDisplay } from 'common/utils/string.utils';

import styles from './ApplicationsTableRow.module.scss';

interface ApplicationsTableRowProps {
  application: BorrowerApplicationDto;
  currentTab: StatusCategoryTab;
}

const ApplicationsTableRow = ({ application, currentTab }: ApplicationsTableRowProps) => {
  const navigator = useNavigate();

  const { applicationsStore } = useContext(RootStoreContext);

  const handleTableRowClick = () => {
    navigator(generatePath(ApplicationRoute.Application, { id: application.id }));
  };

  const tableRowClass =
    currentTab === StatusCategoryTab.Active ? styles.tableRowTemplate : styles.tableRowTemplateInactive;

  return (
    <TableRow className={tableRowClass} onClick={handleTableRowClick}>
      <TableBodyCell>{prepareVariableForTableDisplay(application.displayId)}</TableBodyCell>
      <TableBodyCell>{convertBorrowerNames(application.borrowerFirstName, application.borrowerLastName)}</TableBodyCell>
      <TableBodyCell>
        {convertBorrowerNames(application.coborrowerFirstName, application.coborrowerLastName)}
      </TableBodyCell>
      <TableBodyCell>{getDateWithFormat(application.applicationDate, DateFormats.StandardDateFormat)}</TableBodyCell>
      <TableBodyCell>
        <div className={styles.loanAmount}>{convertLoanAmount(application.loanAmount)}</div>
      </TableBodyCell>
      {currentTab === StatusCategoryTab.Active && (
        <>
          <TableBodyCell>{convertStatus(application.status)}</TableBodyCell>
          <TableBodyCell>
            {!!application.borrowerHomeImprovementEstimatesOrContractsRequired &&
            !application.borrowerHomeImprovementEstimatesOrContractsStatus ? (
              <div className={styles.cellLabel}>Upload Work Order</div>
            ) : (
              APPLICATION_TABLE_EMPTY_VALUE
            )}
          </TableBodyCell>
        </>
      )}

      {currentTab === StatusCategoryTab.Inactive && (
        <TableBodyCell>{getLoanDecision(application.declineReasons, application.status)}</TableBodyCell>
      )}
    </TableRow>
  );
};

export default ApplicationsTableRow;
